import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { CollectionsProvider } from "./data/collections";

import "./index.css";

const root = document.getElementById("root");
if (root !== null) {
  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <CollectionsProvider>
          <App />
        </CollectionsProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}
